/**
 * Bootstrap Carousel Swipe v1.1
 *
 * jQuery plugin to enable swipe gestures on Bootstrap 3 carousels.
 * Examples and documentation: https://github.com/maaaaark/bcSwipe
 *
 * Licensed under the MIT license.
 */

import $ from 'jquery';

function bcSwipe(carousel, settings) {
  let config = {
    threshold: 50,
  };
  if (settings) {
    config = Object.assign(config, settings);
  }

  let stillMoving = false;
  let start;

  if ('ontouchstart' in document.documentElement) {
    carousel.addEventListener('touchstart', onTouchStart, false);
  }

  function onTouchStart(e) {
    if (e.target.dataset.swipeDisabled !== 'true' && e.touches.length === 1) {
      start = e.touches[0].pageX;
      stillMoving = true;
      carousel.addEventListener('touchmove', onTouchMove, false);
    }
  }

  function onTouchMove(e) {
    if (stillMoving) {
      const x = e.touches[0].pageX;
      const difference = start - x;
      if (Math.abs(difference) >= config.threshold) {
        cancelTouch();
        if (difference > 0) {
          $(carousel).carousel('next');
        } else {
          $(carousel).carousel('prev');
        }
      }
    }
  }

  function cancelTouch() {
    carousel.removeEventListener('touchmove', onTouchMove);
    start = null;
    stillMoving = false;
  }

  return this;
}

export default (carousel, settings) => bcSwipe(carousel, settings);
